import React, { useEffect } from 'react';
import { LoadingDots } from '@workday/canvas-kit-react/loading-dots';
import { useInitNewAuthenticatorQuery, useUpdateAuthenticatorMutation } from '../../../../slices/account-api.slice';
import { SecondaryButton, TertiaryButton } from '@workday/canvas-kit-react/button';
import styles from './UpdateAuthenticator.module.scss';
import { AuthenticatorQrCode } from '../../../../shared/authenticator-qr-code/authenticator-qr-code';
import { useTranslation } from 'react-i18next';

export function UpdateAuthenticator({ onPrevious, onCloseModal }) {
    const { data: authenticator, isLoading, isError } = useInitNewAuthenticatorQuery();

    const { t } = useTranslation('account');

    const [updateAuthenticator, updateAuthenticatorMutation] = useUpdateAuthenticatorMutation();

    useEffect(() => {
        if (updateAuthenticatorMutation.isSuccess) {
            onCloseModal();
        }
    }, [onCloseModal, updateAuthenticatorMutation]);

    function onSubmit(payload) {
        updateAuthenticator(payload);
    }

    return isLoading ? (
        <LoadingDots role='progressbar' />
    ) : isError ? (
        <div className={styles.updateAuthenticator}>
            <h1>{t('UpdateAuthenticator.title')}</h1>
            <h2>{t('UpdateAuthenticator.description')}</h2>
            <SecondaryButton type='button' onClick={onPrevious}>
                {t('UpdateAuthenticator.backButton')}
            </SecondaryButton>
        </div>
    ) : (
        <div className={styles.updateAuthenticator}>
            {authenticator && (
                <AuthenticatorQrCode
                    title={t('UpdateAuthenticator.qrCodeTitle')}
                    authenticator={authenticator}
                    mutation={updateAuthenticatorMutation}
                    onSubmit={onSubmit}
                />
            )}
            <TertiaryButton className={styles.cancelButton} type='button' size='large' onClick={onCloseModal}>
                {t('Common.cancel', { ns: 'shared' })}
            </TertiaryButton>
        </div>
    );
}
